import React, { useContext, useEffect, useState } from 'react';
import Form from 'synapps-forms-react-module';
import { useHistory, useLocation, useParams } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import {
    changeVisibleOfField,
    deleteFormEntry,
    editFormEntry,
    getFormStructure,
    uploadMedia
} from '../../../../redux/DynamicForms/DynamicFormsAction';
import { CircularProgress } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import FormStructureHeader from './FormStructureHeader';
import { AlertDialog } from '../../../UI';
import MessagesContext from '../../../../contexts/messagesContext';
import WithPatientFileHeader from '../../../PatientFileHeader/WithPatientFileHeader';
import useCheckMobileScreen from '../../../../hooks/useWidth';
import useBlockRoute from '../../../../hooks/useBlockRoute';
import ErrorBoundary from '../../../UI/error-boundry/index';
import { createLoadingSelector } from '../../../../redux/Loading/LoadingSelector';
import { GET_FORM_STRUCTURE } from '../../../../redux/DynamicForms/DynamicFormsType';
import useCheckAccess from '../../../../hooks/useCheckAccess';
import { getClinicId } from '../../../../utils/storage';
import LanguageContext from '../../../../contexts/languageContext';

const styles = makeStyles({
    progressContainer: {
        height: 'calc(100vh - 200px)',
        textAlign: 'center',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%'
    }
});
const FormStructureEdit = () => {
    const isMobile = useCheckMobileScreen();
    const { messages } = useContext(MessagesContext);
    const classes = styles();
    const params = useParams();
    const { state } = useLocation();
    const { notEditClinical } = useCheckAccess();
    const formId = params?.form_id;
    const [submitted, setSubmitted] = useState(false);
    const [formValue, setFormValue] = useState(null);
    const [openAlert, setOpenAlert] = useState(false);
    const dispatch = useDispatch();
    const history = useHistory();
    const loadingSelector = createLoadingSelector(GET_FORM_STRUCTURE.REQUEST);
    const isLoading = useSelector(loadingSelector);
    const formStructure = useSelector((state) => state.dynamicForms.formStructure);
    const entry = useSelector(
        (state) =>
            state.dynamicForms.formEntries.entries &&
            state.dynamicForms.formEntries.entries.find((item) => item.id === +formId)
    );
    const formName = entry?.structure?.name;
    // const defaultUrl = entries?.length ? entries[0]?.id : '';
    const url = `/${params?.clinicId}/patient/${params?.id}/forms/form`;
    const [hasChanged, setHasChanged] = useState(false);
    const { dialog, setDialog, setUnBlock } = useBlockRoute(hasChanged);
    const media = useSelector((state) => state.dynamicForms.medias?.[formName]);
    const { lang } = useContext(LanguageContext);

    useEffect(() => {
        if (formName) {
            dispatch(getFormStructure(formName));
        }
    }, [formName]);

    useEffect(() => {
        if (entry?.content) {
            setFormValue(entry?.content);
        }
    }, [entry?.content]);

    const handleUnBlockAndResetChanges = () => {
        setUnBlock(true);
        setHasChanged(false);
        setDialog(false);
    };
    const handleSubmission = async (form) => {
        setSubmitted(true);

        await handleEditFormEntry(form);
        setSubmitted(false);
        if (isMobile) {
            history.replace(url);
        }
    };

    const handleEditFormEntry = async (form) => {
        const param = {
            // subject_id: patientId,
            content: form,
            origin: getClinicId()
        };
        await dispatch(editFormEntry(formName, +formId, param));
    };
    const handleAlertDialog = () => {
        setOpenAlert(true);
    };
    const handleDeleteForm = () => {
        dispatch(deleteFormEntry(formName, +formId));
        handleUnBlockAndResetChanges();
        if (isMobile) {
            history.replace(url);
        } else {
            history.replace(`${url}/newForm`);
        }
    };
    const handleUploadMedia = ({ file, fieldName }) => {
        dispatch(uploadMedia(file, formName, fieldName));
    };
    const handleChangeVisibleField = (name, visible) => {
        dispatch(changeVisibleOfField(name, visible));
    };

    const handleCloseDialog = () => {
        setDialog(false);
    };
    const handleCancel = () => {
        history.goBack();
    };
    return (
        <>
            <AlertDialog
                open={openAlert}
                alertText={messages.alerts.deleteFormEntryNew}
                cancelText={messages.cancel}
                confirmText={messages.yes}
                handleAction={handleDeleteForm}
                handleClose={() => setOpenAlert(false)}
            />
            <AlertDialog
                open={dialog}
                alertText={messages.alerts.unBlockFormRoute}
                cancelText={messages.alerts.deleteChanges}
                confirmText={messages.alerts.returnToForm}
                primaryConfirmButton
                handleAction={handleCloseDialog}
                handleClose={handleUnBlockAndResetChanges}
                handleClickOutSide={handleCloseDialog}
            />

            {isLoading ? (
                <div className={classes.progressContainer}>
                    <CircularProgress />
                </div>
            ) : (
                formStructure && (
                    <>
                        <FormStructureHeader
                            formStructure={formStructure}
                            entry={entry}
                            state={state}
                            handleDeleteForm={handleAlertDialog}
                            notEditClinical={notEditClinical}
                        />
                        <ErrorBoundary>
                            <Form
                                formStructure={formStructure}
                                handleSubmit={handleSubmission}
                                prevFormValues={formValue}
                                submitted={submitted || notEditClinical}
                                uploadMedia={handleUploadMedia}
                                medias={media}
                                handleChangeVisible={handleChangeVisibleField}
                                noAccess={notEditClinical}
                                formEntryHasChanged={setHasChanged}
                                handleCancel={handleCancel}
                                lang={lang}
                            />
                        </ErrorBoundary>
                    </>
                )
            )}
        </>
    );
};

export default WithPatientFileHeader(FormStructureEdit, ['sidebar', 'visit'], false, '#fff');
